import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_CONDITIONS } from "./actionTypes"

import {
  getConditionsSuccess,
  getConditionsFail
} from "./actions"

import localForage from 'localforage';

//Include Both Helper File with needed methods
import { getConditions } from "../../helpers/backend_helper"

function* fetchConditions({ payload: setConditionsLoaded }) {
  try {
    const response = yield call(getConditions)
    yield put(getConditionsSuccess(response.data));

    // Attende la scrittura: dopo il download l'app naviga/ricarica e rilegge da IndexedDB
    yield call([localForage, localForage.setItem], "conditions", response.data);
    setConditionsLoaded(true);
  } catch (error) {
    yield put(getConditionsFail(error));
    setConditionsLoaded("error");
  }
}

function* conditionsSaga() {
  yield takeEvery(GET_CONDITIONS, fetchConditions)
}

export default conditionsSaga;
